// helpers/statusHelper.js

export const getStatusConfig = (status) => {
    const map = {
      booked: {
        label: "Booked",
        className: "green-dim",
        circalClassName: "red",
      },
      dispatch: {
        label: "Dispatched",
        className: "red-dim",
        circalClassName: "red",
      },
      return: {
        label: "Returned",
        className: "purple-dim-2",
        circalClassName: "purple",
      },
      prepare: {
        label: "Preparing Return",
        className: "orange-dim-2",
        circalClassName: "orange",
      },
      close: {
        label: "Closed",
        className: "green-dim",
        circalClassName: "green",
      },
      pending: {
        label: "Pending",
        className: "red-dim",
        circalClassName: "red",
      },
      query: {
        label: "Query",
        className: "pink-dim",
        circalClassName: "pink",
      },

      ready_for_dispatch: {
        label: "Ready for Dispatch",
        // one line, centred
        className: "pink-dim text-nowrap text-center",
        circalClassName: "pink",
      },
      
      failed: {
        label: "Failed",
        className: "cross-dim-2",
        circalClassName: "",
      },
      free_set: {
        label: "Failed",
        className: "cross-dim-2",
        circalClassName: "",
      },
     
    };
  
    return map[status] || {
      label: status,
      className: "",
      circalClassName:"red"
      
    };
  };